import React, { Fragment, useEffect, useState, useRef, forwardRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import * as CustomEditor from "ckeditor5-custom-build/build/ckeditor";
import { getFieldsByFormname, showToast } from '../Appcommon';
//import  EmojiPicker  from 'emoji-picker-react';

const CKEditorComponent = forwardRef((props, ref) => {

    const { mentionItems, onEditorChange, content, isMentionsNeeded, isNew, showToolbar, type, addVariable, action } = props;
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [editorInstance, setEditorInstance] = useState(null);
    const [cursorPosition, setCursorPosition] = useState(null);
    let isToolBarNeeded = showToolbar === undefined ? true : showToolbar;
    let isspecfictoolsneeded = type === undefined ? false : true;
    let defaultFontFamily = "Verdana, Geneva, sans-serif";
    let defaultFontSize = "14px";
    const mentionItemsss = [
        { id: '@john', name: 'John Doe' },
        { id: '@jane', name: 'Jane Doe' },
        { id: '@doe', name: 'Doe' }
    ];
    const [orgFieldsOption, setORGFieldsOption] = useState([]);

    useEffect(() => {
        (async () => {
            let orgfields = await getFieldsByFormname("table_21", "organization");
            setORGFieldsOption(orgfields);
        })();
    }, []);

    // Track the cursor position when it changes
    useEffect(() => {
        if (editorInstance) {
            const model = editorInstance.model;
            model.document.selection.on('change', () => {
                const position = model.document.selection.getFirstPosition();
                setCursorPosition(position); // Store cursor position in state
            });
        }
    }, [editorInstance]);

    useEffect(() => {
        if (editorInstance && addVariable !== "") {
            const model = editorInstance.model;
            const insertPosition = cursorPosition || model.document.selection.getFirstPosition();
            if (action === "insertText" || action === "insertEmoji") {
                let textToInsert = addVariable;
                if (action === "insertEmoji" || action === "insertText") {
                    let parts = addVariable.split("#$#");
                    textToInsert = parts[0];
                }
                model.change((writer) => {
                    writer.insertText(textToInsert, insertPosition);
                    const newPosition = insertPosition.getShiftedBy(textToInsert.length);
                    writer.setSelection(newPosition);
                    setCursorPosition(newPosition);
                });
                editorInstance.editing.view.focus();
            }

        }
    }, [addVariable, editorInstance]);
    
    const handleEmojiSelect = (emoji) => {
        if (editorInstance) {
            const model = editorInstance.model;
            const selection = model.document.selection;

            model.change(writer => {
                writer.insertText(emoji.emoji, selection.getFirstPosition());
            });
        }
        setShowEmojiPicker(false); // Hide the emoji picker after selection
    };


    const toggleEmojiPicker = () => {
        setShowEmojiPicker(!showEmojiPicker);
    };
    const applyDefaultStyles = (editor) => {
        editor.execute('fontFamily', { value: defaultFontFamily });
        editor.execute('fontSize', { value: defaultFontSize });
    };

    const convertTextToHtml = () => {
        const lines = plainContent.split(/\r?\n/);
        let formattedContent = lines.map(line => `<div><span style="font-family: ${defaultFontFamily}; font-size: ${defaultFontSize};">${line}</span></div>`).join('');
        return formattedContent;
    };

    const handleOnPasteAction = (editor) => {
        editor.editing.view.document.on('clipboardInput', async (evt, data) => {
            const dataTransfer = data.dataTransfer;
            const insertPosition = editor.model.document.selection.getFirstPosition();
            const plainContent = dataTransfer.getData('text/plain');
            if (plainContent !== "") {
                const styledContent = await convertTextToHtml(plainContent);
                editor.setData(styledContent);
                //insertHtmlAtCursor(styledContent);
            }
        });
    }

    const insertHtmlAtCursor = (editor, htmlContent) => {
        if (editor && htmlContent) {
            const model = editor.model;
            const doc = model.document;
            const selection = doc.selection;

            if (selection) {
                const insertPosition = model.document.selection.getFirstPosition();
                model.change(writer => {
                    writer.insertText(htmlContent, insertPosition);
                });
            }
        }
    };
    return (
        <div ref={ref} tabIndex={-1}>
            {/* {showEmojiPicker && (
                <div style={{ position: 'absolute', bottom: '50px', right: '10px', zIndex: 9999 }}>
                    <EmojiPicker onEmojiClick={handleEmojiSelect} emojiButtonSize={36} emojiSize={20} previewPosition="none" />
                </div>
            )}{showEmojiPicker &&
        <button
                onClick={toggleEmojiPicker}
                style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '10px',
                    zIndex: 999,
                    padding: '10px',
                    borderRadius: '50%',
                    backgroundColor: '#f0f0f0',
                    border: 'none',
                    cursor: 'pointer',
                }}
            >
                😀
            </button>} */}
            {(isMentionsNeeded && mentionItems.length > 0 && orgFieldsOption.length > 0 || !isMentionsNeeded) && <CKEditor
                editor={CustomEditor}
                data={content}
                config={{
                    toolbar: !isToolBarNeeded ? undefined : type ? ['bold', 'italic', 'strikethrough', 'code'] :
                        {
                            removeItems: ['imageUpload'],
                            shouldNotGroupWhenFull: false,
                        },
                    fontFamily: {
                        options: [
                            'Arial, Helvetica, sans-serif',
                            'Courier New, Courier, monospace',
                            'Georgia, serif',
                            'Lucida Sans Unicode, Lucida Grande, sans-serif',
                            'Tahoma, Geneva, sans-serif',
                            'Times New Roman, Times, serif',
                            'Trebuchet MS, Helvetica, sans-serif',
                            'Verdana, Geneva, sans-serif'
                        ],
                        supportAllValues: true,
                        default: defaultFontFamily
                    },
                    fontSize: {
                        options: [10, 12, 14, 16, 18, 20, 22, 24],
                        supportAllValues: true,
                    },
                    mention: {
                        feeds: [
                            {
                                marker: '#',
                                feed: mentionItems,
                                minimumCharacters: 0,
                                dropdownLimit: 100,
                                itemRenderer: (item) => {
                                    return `${item.name}`; // Customize item rendering
                                }
                            },
                            {
                                marker: '@',
                                feed: orgFieldsOption,
                                minimumCharacters: 0,
                                dropdownLimit: 100,
                                itemRenderer: (item) => {
                                    return `${item.name}`; // Customize item rendering
                                }
                            }
                        ]
                    }
                }}
                onClick={(evt, editor) => {
                    console.log("On Toolbar click", evt.domEvent.target.tagName)
                    if (evt.domEvent.target.tagName === 'IMG') {
                        //console.log('Image clicked');
                    }
                }}
                onReady={editor => {
                    console.log("Editor is ready!", editor);
                    applyDefaultStyles(editor);
                    setEditorInstance(editor);
                    //handleOnPasteAction(editor);
                    if (isNew) {
                        //editor.execute( 'heading', { value: 'normal' } );
                        // Apply the default font style to the editor content
                        editor.editing.view.change(writer => {
                            writer.setStyle(
                                'font-family',
                                defaultFontFamily,
                                editor.editing.view.document.getRoot()
                            );
                            writer.setStyle(
                                'font-size',
                                defaultFontSize,
                                editor.editing.view.document.getRoot()
                            );
                        });

                        // Make Arial the default selection in the fontFamily dropdown
                        editor.commands.get('fontFamily').value = defaultFontFamily;
                        // Make 16px the default selection in the fontSize dropdown
                        editor.commands.get('fontSize').value = defaultFontSize;

                        editor.commands.get('imageUpload').on('execute', () => {
                            showToast("Not Supported", "top-right", "error");
                        });

                        editor.model.document.on('change:data', () => {
                            const model = editor.model;
                            const selection = model.document.selection;

                            for (const range of selection.getRanges()) {
                                for (const item of range.getItems()) {
                                    if (item.name === 'image') {
                                        console.log('Image inserted:', item.getAttribute('src'));
                                        // Add custom handling code here
                                    }
                                }
                            }
                        });
                        
                    }

                }}
                onChange={(event, editor) => {
                    let data = editor.getData();
                    // Apply inline styles to all <td> elements
                    //editor.execute( 'heading', { value: 'normal' } );
                    //applyDefaultStyles(editor);
                    if (onEditorChange) {
                        onEditorChange(data, editor);
                    }
                }}
            />
            }

        </div>
    );
});

export default CKEditorComponent;